/**
 * reviewEmpty — the Review tab's empty-state copy (G10). A zero-swim tester must
 * not be pointed at a Swim tab that has nothing to tap. A swimmer who declined
 * Health is told so, with the Settings path, before anything about swim counts
 * (beta-review panel, 2026-09-13: the declined state was silent on every tab).
 */
export function reviewEmptyCopy(totalSwims: number, healthOff = false): string {
  if (healthOff) {
    return "Swim Set Club can't read your swims. Turn on Health access in Settings, Privacy & Security, Health, Swim Set.";
  }
  if (totalSwims === 0) {
    return "Record your first swim, then come back here to see its story.";
  }
  return "Open the Swim tab and tap any swim to see its story.";
}
